import {db} from '@src/services/db'
import {useObservable} from '@vueuse/rxjs'
import {liveQuery} from 'dexie'
import Channel from '@src/types/Channel'
import {Ref} from 'vue'

export function useChannels() {

    function activeChannels(): Ref<Channel[]> {
        return useObservable(
            // @ts-ignore
            liveQuery(async () => {
                return db.channels
                    .where('type')
                    .equals('whatsapp')
                    .or('type')
                    .equals('waapi')
                    .and(channel => channel.status === 'connected')
                    .toArray()
            }),
            {
                initialValue: []
            }
        )
    }

    function getChannels(): Ref<Channel[]> {
        return useObservable(
            // @ts-ignore
            liveQuery(async () => {
                return db.channels.toArray()
            }),
            {
                initialValue: []
            }
        )
    }

    return {
        activeChannels,
        getChannels
    }
}
